import { render, staticRenderFns } from "./DemandCard.vue?vue&type=template&id=0ae5f258&"
import script from "./DemandCard.vue?vue&type=script&lang=ts&"
export * from "./DemandCard.vue?vue&type=script&lang=ts&"
import style0 from "./DemandCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports